import * as React from "react";

type CpFormContextType = {
  submit: () => Promise<void>;
  id: string;
};

export const CpFormContext = React.createContext<CpFormContextType>(null as any);
